import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import OfficialCommonBtn from '../atoms/officialCommonBtn'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.article`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  margin-bottom: 60px;
  border-radius: 5px;
  padding: 20px;
  height: 200px;
  overflow: hidden;
  background-image: url(/images/column/common/introductionLowerBack.png);
  position: relative;

  p {
    line-height: unset;
    padding: 0px;
  }

  .intro-txt {
    font-size: 20px;
    color: #fff;
    font-weight: 600;
    padding: 0px;
  }

  .btn-wrap {
    width: 100%;
  }

  .intro-img {
    position: absolute;
    bottom: -6px;
    left: 20px;

    img {
      padding: 0;
      height: 124px;
    }
  }

  Button.mega {
    font-size: 26px;
    height: 60px;
    margin-top: 10px;
  }

  .p-cta-btns {
    margin-bottom: 0;

    button {
      margin-bottom: 0;
      height: 40px;
    }
  }

  ${BreakPoints.large} {
  }
`

/**
 * コラム記事詳細下部製品誘導エリア3(AC)
 * @constructor
 */
const Conclusion003 = () => {
  const routeParam1 = useRouteParam(
    'https://sign-up.kintaicloud.jp/sign-up/?utm_source=article&utm_medium=post&utm_campaign=pattern_03_Con'
  )
  const routeParam2 = useRouteParam(
    'https://www.kintaicloud.jp/download/?utm_source=article&utm_medium=post&utm_campaign=pattern_03_Con'
  )
  const routeParam3 = useRouteParam(
    'https://www.kintaicloud.jp/contact/?utm_source=article&utm_medium=post&utm_campaign=pattern_03_Con'
  )

  return (
    <Wrapper>
      <p className="intro-txt">
        勤怠管理でお困りのことはありませんか？お悩みをお聞かせください
      </p>
      <div className="intro-img">
        <img
          src="/images/column/common/introductionLower001.png"
          alt="キンクラ"
        />
      </div>
      <div className="btn-wrap">
        <OfficialCommonBtn
          size="mega"
          level="strong"
          onClick={() => window.open(routeParam3)}
          className="strong-btn"
        >
          勤怠システムのお問い合わせ
        </OfficialCommonBtn>
        <div className="p-cta-btns">
          <OfficialCommonBtn
            size="large"
            onClick={() => window.open(routeParam2)}
          >
            資料ダウンロード
          </OfficialCommonBtn>
          <OfficialCommonBtn
            size="large"
            onClick={() => window.open(routeParam1)}
          >
            無料トライアル
          </OfficialCommonBtn>
        </div>
      </div>
    </Wrapper>
  )
}

export default Conclusion003
